<template lang="pug">
	.project-list-main(v-if="Template.SelectedTemplate" :style="{'height': `calc(100% - ${Layout.headerHeight}px)`, 'top': `${Layout.headerHeight}px`, 'left': `${Layout.templatesPlaneWidth}px`}")
		.project-list-header(v-if="Template.SelectedTemplate")
			.caption
				.template-title-wrapper
					.template-title {{Template.SelectedTemplate.title}}
				.options-buttons
					.options-button-folder(@click="createFolder()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Create a new folder for this template', html: true}")
						.btn.btn-sm.btn-block.btn-outline-secondary
							i.fa.fa-folder
					.options-button(@click="create()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Create a new project from this template', html: true}")
						.btn.btn-sm.btn-block.btn-outline-secondary
							.fa.fa-plus
			.extra-options
				.left-part
					.btn.btn-sm.btn-block.btn-outline-secondary(v-if="!showTimestamps" v-on:click="toggleTimestamps" v-b-tooltip.hover.topright="{delay: { show: 100, hide: 100 }, title: 'Show timestamps of last upload', html: true}")
						.btn-wrapper
							.fa.fa-clock-o
					.btn.btn-sm.btn-block.btn-outline-secondary(v-else v-on:click="toggleTimestamps" v-b-tooltip.hover.topright="{delay: { show: 100, hide: 100 }, title: 'Hide timestamps of last upload', html: true}")
						.btn-wrapper
							.fa.fa-clock-o
					.btn.btn-sm.btn-block.btn-outline-secondary(v-if="selectedProjects.size > 1" v-on:click="uploadSelectedProjects" v-b-tooltip.hover.topright="{delay: { show: 100, hide: 100 }, title: 'Upload selected projects', html: true}")
						.btn-wrapper
							.fa.fa-upload
				.right-part
					small Sort by
					select.custom-select.custom-select-sm(v-model="projectsSort")
						option(:value="'created'") Date created
						option(:value="'uploaded'") Last uploaded
		.project-search
			.input-wrapper
				input(id="searchInput" placeholder="Search" size="64" v-model="searchTitle" type="text")
				.cancel-wrapper(@click="searchClick()")
					.cancel-search
						i.fa.fa-search(v-if="!search")
						svg(v-else width="24" height="24" viewBox="0 0 24 24" :style="{'margin-top': '4px'}")
							path(fill="#c8ced3" d="M18.4 4L12 10.4L5.6 4L4 5.6L10.4 12L4 18.4L5.6 20L12 13.6L18.4 20L20 18.4L13.6 12L20 5.6L18.4 4Z")
		.project-list-wrapper(:style="{'height': `calc(100% - ${Layout.headerHeight}px - 80px)`}")
			.folder(v-for="(folder, index) in folders" :class="{selected: Project.SelectedFolder && Project.SelectedFolder.id === folder.id}" @click="Project.selectFolder(folder.id)")
				.folder-wrapper
					i.fa.fa-folder-open(v-if="Project.SelectedFolder && Project.SelectedFolder.id === folder.id")
					i.fa.fa-folder(v-else)
					.folder-title-wrapper
						.folder-title {{folder.title}}
					.folder-edit-wrapper.selected(v-if="Project.SelectedFolder && Project.SelectedFolder.id === folder.id")
						.folder-edit
							ProjectFolderActions(:index="index")
							span
				.folder-content(v-if="Project.SelectedFolder && Project.SelectedFolder.id === folder.id")
					.project(v-for="(project, index) in projects" v-if="project.folder_id && project.folder_id === folder.id")
						.project-title-wrapper(:class="{selected: Project.SelectedProject && Project.SelectedProject.id === project.id, 'with-timestamp': true}" @click="Project.selectProject(project.id)")
							.project-timestamp(v-on:click.stop="selectForUpload(project, $event.target)" v-if="showTimestamps" :class="{'timestamp-selected': selectedProjects.has(project.id)}")
								.project-timestamp-text {{project.lastUploaded}}
							.project-timestamp-placeholder(v-else)
							.project-title
								.project-title-text(:class="{'with-timestamp': showTimestamps}") {{project.title}}
						.project-edit-wrapper.selected(v-show="Project.SelectedProject && Project.SelectedProject.id === project.id")
							.project-edit
								ProjectActions(:index="index")
								span

			.project(v-for="(project, index) in projects" v-if="!project.folder_id")
				.project-title-wrapper(:class="{selected: Project.SelectedProject && Project.SelectedProject.id === project.id, 'with-timestamp': true}" @click="Project.selectProject(project.id)")
					.project-timestamp(v-on:click.stop="selectForUpload(project, $event.target)" v-if="showTimestamps" :class="{'timestamp-selected': selectedProjects.has(project.id)}")
						.project-timestamp-text {{project.lastUploaded}}
					.project-timestamp-placeholder(v-else)
					.project-title
						.project-title-text(:class="{'with-timestamp': showTimestamps}") {{project.title}}
				.project-edit-wrapper.selected(v-show="Project.SelectedProject && Project.SelectedProject.id === project.id")
					.project-edit
						ProjectActions(:index="index")
						span

</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Template } 		from './../../services/Template'
	import { Project } 			from './../../services/Project'
	import { Layout } 			from './../../services/Layout'

	import ProjectActions 		from './ProjectActions'
	import ProjectFolderActions from "./ProjectFolderActions";
	import dayjs from "dayjs";

	export default {
		name: 'ProjectList',
		mixins: [Screen],
		screen: {
			updateOn: ["Template Changed", "Selected Template Changed", "Selected Project Changed", "Selected Folder Changed", "Projects Changed", "Folders Changed", "Project Renamed", "Folder Renamed"],
			events: {
				"Projects Changed": function () {
					this.folders = Project.getFoldersByTemplate(Template.SelectedTemplate.id);
					this.projects = Project.getProjectsByTemplate(Template.SelectedTemplate.id);

					this.searchTitle = '';
					this.projectsSort = 'created';
					this.showTimestamps = false;

					this.$forceUpdate();
				},
				"Project Changed": function (projectId) {
					if (this.projects[projectId]) {
						this.projects[projectId] = _.clone(Project.Projects[projectId]);
					}
					if (this.allProjects[projectId]) {
						this.allProjects[projectId] = _.clone(Project.Projects[projectId]);
					}
					this.update();

				},
			}
		},
		components: {
			ProjectActions,
			ProjectFolderActions
		},
		data() {

			this.Template = Template;
			this.Project = Project;
			this.Layout = Layout;

			this.projects = [];
			this.folders = [];
			this.projectWithFolders = [];
			this.projectsWithoutFolders = [];

			this.selectedProjects = new Set();

			return {
				searchTitle: '',
				projectsSort: 'created',
				showTimestamps: false,
				//selectedProjects: new Set(),
				search: false,
				showed: true
			};

		},
		watch: {
			searchTitle(val) {
				val = val.toLowerCase();
				if (val.length === 0) {
					this.projects = this.allProjects;
					this.folders = this.allFolders;
					this.search = false;
				} else {
					this.projects = this.allProjects.filter(project => project.title.toLowerCase().includes(val));
					this.folders = this.allFolders.filter(folder => folder.title.toLowerCase().includes(val));
					this.search = true;
				}
				this.sortProjects(this.projectsSort);

			},
			projectsSort(val) {
				this.sortProjects(val);
			}
		},
		methods: {

			collectData() {

				this.allFolders = Project.getFoldersByTemplate(Template.SelectedTemplate.id);
				this.folders = Project.getFoldersByTemplate(Template.SelectedTemplate.id);

				this.allProjects = Project.getProjectsByTemplate(Template.SelectedTemplate.id);
				this.projects = Project.getProjectsByTemplate(Template.SelectedTemplate.id);

				if (this.searchTitle.length !== 0) {
					this.projects = this.allProjects.filter(project => project.title.toLowerCase().includes(this.searchTitle.toLowerCase()));
					this.folders = this.allFolders.filter(folder => folder.title.toLowerCase().includes(this.searchTitle.toLowerCase()));
				}

				this.projectWithFolders = this.projects.filter(project => project.folder_id !== null && project.folder_id !== undefined && project.folder_id !== 0);
				this.projectsWithoutFolders = this.projects.filter(project => !project.folder_id);

				this.sortProjects(this.projectsSort);
				this.selectedProjects = new Set();
				Project._SelectedProjects = this.selectedProjects;

			},

			selectForUpload(project, target) {
				if (!this.selectedProjects.has(project.id) && this.selectedProjects.size < 20) {
					this.selectedProjects.add(project.id);
					//target.classList.add('timestamp-selected');
				}
				else {
					this.selectedProjects.delete(project.id);
					//target.classList.remove('timestamp-selected');
				}
				this.$forceUpdate();
				Project._SelectedProjects = this.selectedProjects;
			},

			uploadSelectedProjects() {
				if (this.selectedProjects.size > 1) {
					Broadcast.call("Show Upload Amazon S3 Multiple", [this.selectedProjects]);
				}
			},

			sortProjects(value) {
				if (value === 'created') {
					this.projects = this.allProjects.filter(project => project.title.toLowerCase().includes(this.searchTitle.toLowerCase()));
				} else {
					this.projects = this.projects.sort((a, b) => {
						if (!a.timestamp) return -1;
						if (!b.timestamp) return 1;
						if (!a.timestamp && !b.timestamp) return a.id > b.id ? -1 : 1
						return a.timestamp > b.timestamp ? 1 : -1;
					});
				}
			},

			toggleTimestamps() {
				this.showTimestamps = !this.showTimestamps;
				this.selectedProjects = new Set();
				Project._SelectedProjects = this.selectedProjects;
			},

			searchClick() {
				if (this.search) {
					this.searchTitle = '';
				}
				document.getElementById('searchInput').focus();

			},

			create() {

				Broadcast.call("Show Project Actions Create");

			},

			createFolder() {

				Broadcast.call("Show Project Folder Actions Create");

			}
		}
	}
</script>

<style lang="sass">

	.project-search
		height: 42px
		border-bottom: 1px solid #23282c
		display: flex

		.input-wrapper
			display: flex
			margin: auto
			width: 90%
			height: 34px
			border: 1px solid #23282c
			border-radius: 5px
			background-color: #515b65

			.cancel-wrapper
				width: 32px
				height: 32px
				cursor: pointer

				.cancel-search
					width: 32px
					height: 32px

					i.fa.fa-search
						width: 24px
						height: 24px
						margin-top: 6px
						margin-left: 6px
						font-size: 20px


		input
			display: flex
			margin: auto
			padding-left: 7px
			width: 90%
			border: none
			background-color: #515b65
			color: #ffffff

			&:focus-visible
				outline: none

	.project-list-main
		width: 250px
		height: 100%
		background-color: #3a4149
		border-right: 1px solid #23282c
		color: #f3f4f5
		text-align: left
		position: absolute
		left: 0
		top: 0

		.project-list-header
			border-bottom: 1px solid #23282c

		.caption
			font-weight: 500
			cursor: default
			display: flex
			flex-direction: row
			align-items: center
			padding: 10px
			justify-content: space-between

			.in-development
				font-size: 0.775rem
				color: #f86c6b

			.ready
				font-size: 0.775rem
				color: #4dbd74

		.extra-options
			display: flex
			padding: 0 10px 10px 10px
			justify-content: space-between

			.left-part
				display: flex
				flex-direction: row
				align-items: center
				width: 70px
				justify-content: space-between

				.btn
					width: 30px
					height: 30px
					font-size: 20px
					padding: 0px
					box-sizing: content-box
					cursor: pointer

					+ .btn-block
						margin-top: unset

			.right-part
				display: flex
				flex-direction: row
				align-items: center

				small
					white-space: nowrap
					padding-right: 5px

				select
					background-color: #515b65
					border: 1px solid #23282c
					color: whitesmoke
					height: 30px


		.template-title-wrapper
			width: 80%
			display: flex

		.options-buttons
			display: flex

			.options-button
				//top: 1px
				//width: 60px
				//right: -5px
				//padding: 0.75rem 1rem
				padding: 0 7px
				cursor: pointer
				color: #e4e7ea

			.options-button-folder
				//top: 1px
				//width: 60px
				//right: 40px
				//padding: 0.75rem 1rem
				padding: 0 7px
				cursor: pointer
				color: #e4e7ea

			i
				transform: scale(1.5)

				.fa
					position: absolute

		.project-list-wrapper
			overflow-x: hidden
			overflow-y: auto

			&::-webkit-scrollbar
				position: fixed
				width: 10px
				margin-left: -10px
				-webkit-appearance: none
				appearance: none

			&::-webkit-scrollbar-track
				background-color: rgba(0, 0, 0, 0.2)

			&::-webkit-scrollbar-thumb
				height: 50px
				background-color: rgba(0, 0, 0, 0.2)
				background-clip: content-box
				border-color: transparent
				border-radius: 5px

		.project-list
			height: 48px
			display: flex
			align-items: center
			justify-content: left
			border-bottom: 1px solid #23282c
			cursor: pointer

			&:hover
				background-color: #2f353a

			&:active
				background-color: #f3f4f5
				color: #2f353a

			&.selected
				background-color: #20a8d8

			.project-list-title

				i
					margin-right: 10px

		.folder
			/*height: 48px*/
			display: flex
			border-bottom: 1px solid #23282c
			cursor: pointer
			background-color: #292b2d
			flex-direction: column

			.folder-content
				padding-left: 1rem
				background-color: #2f353a

				.project
					background-color: #3a4149
					border-left: 1px solid #23282c

				.project:last-child
					border-bottom: unset

			.folder-wrapper
				height: 48px
				display: flex
				border-bottom: 1px solid #23282c
				cursor: pointer
				background-color: #292b2d
				flex-direction: row

				.folder-title-wrapper
					display: flex
					align-items: center
					width: 85%

			&.selected
				background-color: #006c92

			.fa
				margin: auto 0
				padding: 0 0.25rem 0 1rem

			.project-title-wrapper
				display: flex
				align-items: center
				width: 85%

				.folder-title
					padding: 0 1rem

			.folder-edit-wrapper
				display: flex
				align-items: center
				width: 15%

		.project
			height: 48px
			display: flex
			justify-content: space-between
			border-bottom: 1px solid #23282c
			cursor: pointer

			&:hover
				background-color: #2f353a

			&:active
				background-color: #f3f4f5
				color: #2f353a

			.project-title-wrapper
				display: flex
				align-items: center
				width: 85%
				justify-content: flex-start

				&.selected
					background-color: #20a8d8

				.project-title
					//padding: 0 1rem
					//line-height: 1.25
					display: flex

					.project-title-text
						padding-left: 1rem

					.project-title-text.with-timestamp
						padding-left: 4px


				.project-timestamp
					min-width: 20%
					width: 20%
					height: 100%
					font-size: 75%
					font-style: italic
					background-color: #2E3237
					display: flex

					&.timestamp-selected
						background-color: #515b65

					.project-timestamp-text
						padding: 0 3px
						margin: auto 0
						pointer-events: none


				.project-timestamp-placeholder
					//width: 1rem

			.project-edit-wrapper
				display: flex
				align-items: center
				width: 15%

				&.selected
					background-color: #20a8d8



</style>

